import { sendBackgroundMessage } from '../../chat/functions';
import { useUpdateStateVariables } from '../../state_variables';
import { useBMCDailyReminderState } from '../hooks/useDailyReminderState';
import { DailySurveyReminder } from './DailySurveyReminder';

type Props = {
  children: React.ReactNode;
};

export const BMCDailySurveyReminderProvider = (props: Props) => {
  const { children } = props;

  const { should_show_reminder, refetch } = useBMCDailyReminderState();
  const updateStateVariables = useUpdateStateVariables();

  const onPressSkip = async () => {
    // Set the skipped variable
    await updateStateVariables([
      {
        var_name: 'BMC_daily_survey_skipped',
        operator: '=',
        value: 'true',
        value_type: 'primitive',
      },
    ]);

    refetch();
  };

  const onPressStart = async () => {
    // Start the survey and hide the notification
    sendBackgroundMessage('BMC_trials_entry_point');

    await updateStateVariables([
      {
        var_name: 'Daily_survey_status',
        operator: '=',
        value: '1',
        value_type: 'primitive',
      },
    ]);

    refetch();
  };

  return (
    <>
      {children}
      {should_show_reminder ? (
        <DailySurveyReminder onSkip={onPressSkip} onStart={onPressStart} />
      ) : null}
    </>
  );
};
